import { useEffect, useState } from "react";

/**
 * A live-feed style ticker that cycles through a list of items.
 * Each item is an object: { time, badge, text, color }
 */
export default function LiveTicker({
  items,
  interval = 2800,
  className = "",
  testId,
}) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (!items?.length) return;
    const id = setInterval(() => setI((v) => (v + 1) % items.length), interval);
    return () => clearInterval(id);
  }, [items, interval]);
  if (!items?.length) return null;
  const current = items[i];
  return (
    <div
      data-testid={testId}
      className={`relative border border-white/10 bg-white/[0.04] backdrop-blur-sm p-4 overflow-hidden ${className}`}
    >
      <div className="flex items-center gap-3 mb-2">
        <span className="relative inline-flex h-2 w-2">
          <span
            className="absolute inset-0 rounded-full animate-ping"
            style={{ background: current.color || "#16A374" }}
          />
          <span
            className="relative inline-block h-2 w-2 rounded-full"
            style={{ background: current.color || "#16A374" }}
          />
        </span>
        <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-white/60">
          Live · {current.time}
        </p>
      </div>
      <p
        key={i}
        className="font-display text-sm md:text-base font-semibold text-white leading-snug fade-up"
      >
        <span
          className="font-mono text-[10px] tracking-[0.2em] uppercase mr-2 px-1.5 py-0.5 border"
          style={{ borderColor: current.color, color: current.color }}
        >
          {current.badge}
        </span>
        {current.text}
      </p>
    </div>
  );
}
